import React, { useState } from "react";
import ButtonsContainer from "./components/ButtonsContainer";
import DisplayContainer from "./components/DisplayContainer";
import "./styles.css";

function App() {
  const [display, setDisplay] = useState("");
  const [result, setResult] = useState("");
  const [isDegree, setIsDegree] = useState(true); // Toggle between degree and radian mode

  function handleClick(e) {
    const targetValue = e.target.name;
    setDisplay((prev) => prev + targetValue);
  }

  function operatorClick(operator) {
    if (display === "" || "+-*/^".includes(display.slice(-1))) return;
    setDisplay((prev) => prev + operator);
  }

  function handleEqual() {
    try {
      let expression = display.replace(/\^/g, "**"); // Convert ^ to ** for exponentiation
      let resultValue = evaluateExpression(expression);
      setResult(resultValue);
    } catch (error) {
      setResult("Error");
    }
  }

  function evaluateExpression(expression) {
    try {
      let formattedExpression = expression.replace(/sin|cos|tan|log|sqrt/g, (match) => {
        return `Math.${match}`;
      });

      formattedExpression = formattedExpression.replace(/π/g, "Math.PI");

      if (isDegree) {
        formattedExpression = formattedExpression.replace(/Math.(sin|cos|tan)\((.*?)\)/g, (match, func, angle) => {
          return `Math.${func}(${angle} * (Math.PI / 180))`;
        });
      }

      let result = Function(`return ${formattedExpression}`)(); // Evaluate safely
      return Number.isFinite(result) ? parseFloat(result.toFixed(6)) : "Error";
    } catch (error) {
      return "Error";
    }
  }

  function clear() {
    setDisplay("");
    setResult("");
  }

  function backspace() {
    setDisplay((prev) => prev.slice(0, -1));
  }

  function toggleMode() {
    setIsDegree(!isDegree);
  }

  return (
    <div className="container">
      <div className="calculator">
        <h2 className="title">Let's Calculate It</h2>
        <DisplayContainer display={display} result={result} backspace={backspace} clear={clear} />
        <ButtonsContainer operatorClick={operatorClick} handleClick={handleClick} handleEqual={handleEqual} />
        <button className="mode-toggle" onClick={toggleMode}>
          Mode: {isDegree ? "Degree" : "Radian"}
        </button>
      </div>
    </div>
  );
}

export default App;
